import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import EirActionModal from '../eir-action-modal/EirActionModal';
import fetchInfo from '../../../util/fetchModalData';
import { getCookie } from '../../hooks/useCookie';

const { publicRuntimeConfig } = getConfig();

const MobileUpgradeIneligibleModal = ({
  upgradeIneligible,
  isStandaloneHandset,
  openKeepNumberCheck,
}) => {
  const router = useRouter();
  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [load, setLoad] = useState(true);

  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'existing_mobile_customer_upgrade_not_eligible',
      });
      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.error('error', error);
    }
  };

  useEffect(() => {
    getCmsData();
  }, []);

  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID}
      open={upgradeIneligible.value}
      handleClose={upgradeIneligible.disable}
      desktopImageSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI_SERVER}${
        cmsCollectionData?.attributes?.desktopImage?.data?.attributes?.url || ''
      }`}
      mobileImageSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI_SERVER}${
        cmsCollectionData?.attributes?.mobileImage?.data?.attributes?.url || ''
      }`}
      desktopImageAlt={
        cmsCollectionData?.attributes?.desktopImage?.data?.attributes?.alternativeText
      }
      mobileImageAlt={cmsCollectionData?.attributes?.mobileImage?.data?.attributes?.alternativeText}
      desktopCurveImg={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsCollectionData?.attributes?.desktopCurveImg?.data?.attributes?.url}`}
      mobileCurverImg={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsCollectionData?.attributes?.mobileCurverImg?.data?.attributes?.url}`}
      title={`Hi ${getCookie('customer_Name')}, ${
        cmsCollectionData?.attributes?.title ? cmsCollectionData?.attributes?.title : ''
      }`}
      description={`${
        cmsCollectionData?.attributes?.firstHalfDescription
          ? cmsCollectionData?.attributes?.firstHalfDescription
          : ''
      }
        ${
          cmsCollectionData?.attributes?.secondHalfDescription
            ? cmsCollectionData?.attributes?.secondHalfDescription
            : ''
        }
        `}
      cta={[
        {
          // text: 'Add a new mobile',
          text: cmsCollectionData?.attributes?.cta[0]?.name
            ? cmsCollectionData?.attributes?.cta[0]?.name
            : 'Add a new mobile',
          ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            : '',
          type: 'contained',
          action: () => {
            if (isStandaloneHandset) {
              upgradeIneligible.disable();
            } else {
              router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile/handsets`);
            }
          },
        },
        {
          // text: 'Add a new plan',
          text: cmsCollectionData?.attributes?.cta[1]?.name
            ? cmsCollectionData?.attributes?.cta[1]?.name
            : 'Add a new plan',
          ariaLabel: cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            : '',
          type: 'contained',
          action: () => {
            if (isStandaloneHandset) {
              router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile`);
            } else {
              upgradeIneligible.disable();
              openKeepNumberCheck.enable();
            }
          },
        },
      ]}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      disablecta={false}
      load={load}
    />
  );
};

export default MobileUpgradeIneligibleModal;
